export const subscriptionAccordions = () => {
    const $accordionSection = document.querySelector('.subscription-accordion');
    if ($accordionSection) {
        const $accordionItems = $accordionSection.querySelectorAll('.subscription-accordion__items .accordion');
        if ($accordionItems) {
            $accordionItems.forEach(($accordionItem) => {
                const $accordionHeader = $accordionItem.querySelector('.accordion__header');
                const $accordionArrow = $accordionHeader?.querySelector('svg');
                const $accordionBody = $accordionItem.querySelector('.accordion__body');
                if ($accordionHeader && $accordionBody && $accordionArrow) {
                    $accordionHeader.addEventListener("click", () => {
                        
                        if ($accordionBody.classList.contains("hidden")) {
                            $accordionBody.classList.remove('hidden');
                            $accordionBody.classList.add('flex');
                            $accordionArrow.classList.remove('icon-closed');
                            $accordionArrow.classList.add('icon-open');
                        } else {
                            $accordionBody.classList.add('hidden');
                            $accordionBody.classList.remove('flex');
                            $accordionArrow.classList.remove('icon-open');
                            $accordionArrow.classList.add('icon-closed');
                        }
                    });
                }
            });
        }
    }
}

export default subscriptionAccordions;